<template>
  <div class="index">
    <i class="get_login" @click="checkRecords"></i>
    <i class="rule_btn" @click="$parent.popShow = 'help'"></i>
    <i class="start_btn" @click="goTransform"></i>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    goTransform() {
      if (this.$parent.loginStatus && this.$parent.canTip) {
        this.$parent.popShow = 'checktransform';
        this.$parent.canTip = false; //只用一次
      } else {
        this.$parent.currentPage = 1;
      }
    },
    checkRecords() {
      if (this.$parent.loginStatus) {
        this.$parent.popShow = 'history';
      } else {
        this.$parent.loginShow = true;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.index {
  width: 7.5rem;
  height: 16rem;
  background: url('../assets/bg.png');
  background-size: 100% 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .get_login {
    width: 1.91rem;
    height: 0.49rem;
    position: absolute;
    top: 0.05rem;
    right: 0;
  }
  .rule_btn {
    width: 0.31rem;
    height: 0.31rem;
    position: absolute;
    top: 5.39rem;
    left: 2.82rem;
  }
  .start_btn {
    width: 6.9rem;
    height: 0.9rem;
    position: absolute;
    bottom: 1.45rem;
  }
}
</style>